module.exports = __webpack_public_path__ + "static/image_page_sidebar.0b34c9f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/image_page_sidebar.jpg
// module id = 82
// module chunks = 168707334958949